module.exports = __webpack_public_path__ + "assets/img/header-bg.4e034ff5.png";